import { Pagination } from '@mui/material';
import styled from 'styled-components';

interface PaginationProps {
  currentPage: number;
  pages: number;
  onCurrentPageChange: (page: number) => void;
}

export function PaperPagination(props: PaginationProps): JSX.Element {
  const { currentPage, pages, onCurrentPageChange } = props;

  const handlePageChange = (_: React.ChangeEvent<unknown>, page: number) => {
    onCurrentPageChange(page - 1);
  };

  return (
    <SyledPagination
      count={pages}
      page={currentPage + 1}
      onChange={handlePageChange}
    />
  );
}

const SyledPagination = styled(Pagination).attrs({
  shape: 'rounded',
})``;
